import React from 'react'

export default function HomeScheduleItem(props) {
    return (
        <li>
              <div class="timeline-time ">
                <span class="date">
                  {props.dayName} <span class="badge badge-primary">1</span>
                </span>
                <span class="time">{props.from} - {props.to}</span>
              </div>
              <div class="timeline-icon">
                <a href="javascript:;" />
              </div>
              <div class="timeline-body ">
                <div class="timeline-header">
                  <span class="username">
                    <a href="/course/6577   /">{props.crsName}</a>
                    <small />
                  </span>
                  <span class="pull-right text-muted">{props.lectType} </span>
                </div>
                <div class="location_type">
                  <span />
                  <span class="type"> </span>
                  <span class="location">Room {`${props.roomNo}`}</span>
                </div>
              </div>
            </li>
    )
}



// WEBPACK FOOTER //
// ./src/pages/course/Home/HomeScheduleItem.js